import {
	ChevronLeftIcon,
	ChevronRightIcon,
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronDownIcon,
} from '@heroicons/react/20/solid';

const PAGE_SIZE_OPTIONS = [10, 15, 25, 50];

export const Pagination = ({
	page,
	pageSize,
	totalRows,
	pageSizeOptions = PAGE_SIZE_OPTIONS,
	disabled = false,
	onPageChange,
	onPageSizeChange,
}) => {
	const totalPages = Math.max(1, Math.ceil((totalRows || 0) / pageSize));
	const currentPage = Math.min(Math.max(0, page), totalPages - 1);
	const start = totalRows === 0 ? 0 : currentPage * pageSize + 1;
	const end = Math.min((currentPage + 1) * pageSize, totalRows);

	const goTo = (next) => {
		if (next < 0 || next >= totalPages || next === currentPage) return;
		onPageChange(next);
	};

	return (
		<div className='flex flex-col items-center justify-between gap-3 border-t border-gray-200 px-4 py-3 md:flex-row'>
			<div className='flex items-center gap-3 text-sm text-gray-600'>
				<label className='inline-flex items-center gap-2'>
					<span>Filas por página:</span>
					<span className='relative inline-flex items-center'>
						<select
							value={pageSize}
							disabled={disabled}
							onChange={(e) => onPageSizeChange(Number(e.target.value))}
							className='h-9 appearance-none rounded-md border border-gray-300 bg-white py-1 pl-2 pr-8 text-sm leading-none focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50'
						>
							{pageSizeOptions.map((opt) => (
								<option key={opt} value={opt}>{opt}</option>
							))}
						</select>
						<ChevronDownIcon
							className='pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500'
							aria-hidden='true'
						/>
					</span>
				</label>

				<span className='hidden md:inline'>
					{start}-{end} de {totalRows}
				</span>
			</div>

			<div className='flex items-center gap-1'>
				<NavButton
					onClick={() => goTo(0)}
					disabled={disabled || currentPage === 0}
					label='Primera página'
					icon={<ChevronDoubleLeftIcon className='h-4 w-4' />}
				/>
				<NavButton
					onClick={() => goTo(currentPage - 1)}
					disabled={disabled || currentPage === 0}
					label='Página anterior'
					icon={<ChevronLeftIcon className='h-4 w-4' />}
				/>

				<span className='px-3 text-sm text-gray-700'>
					Página <span className='font-semibold'>{currentPage + 1}</span> de{' '}
					<span className='font-semibold'>{totalPages}</span>
				</span>

				<NavButton
					onClick={() => goTo(currentPage + 1)}
					disabled={disabled || currentPage >= totalPages - 1}
					label='Página siguiente'
					icon={<ChevronRightIcon className='h-4 w-4' />}
				/>
				<NavButton
					onClick={() => goTo(totalPages - 1)}
					disabled={disabled || currentPage >= totalPages - 1}
					label='Última página'
					icon={<ChevronDoubleRightIcon className='h-4 w-4' />}
				/>
			</div>

			<span className='text-xs text-gray-500 md:hidden'>
				{start}-{end} de {totalRows}
			</span>
		</div>
	);
};

const NavButton = ({ onClick, disabled, label, icon }) => (
	<button
		type='button'
		onClick={onClick}
		disabled={disabled}
		aria-label={label}
		className='inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-white'
	>
		{icon}
	</button>
);
